import {
  doGetExternalAppRequest,
  doPostExternalAppRequest,
  doPutExternalAppRequest,
} from "./ApiService";
import { baseHeaders } from "./Headers";

export function checkPortability(phone: string): Promise<any> {
  const url = `/portability/verify-temporary/${phone}?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
    "x-customer-id": localStorage.getItem("x-customer-id")!,
    authorization: "Bearer ".concat(localStorage.getItem("x-access-token")!),
  };
  return doGetExternalAppRequest(url, headers);
}

export function sendSmsPortability(payload: any): Promise<any> {
  const url = `/portability/verify-eligibility/${
    payload.phonePort
  }?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}&resendToken=${
    payload.resendToken ? "1" : "0"
  }`;
  const headers = {
    ...baseHeaders,
    "x-msisdn": `55${localStorage.getItem("msisdn")!}`,
    authorization: "Bearer ".concat(localStorage.getItem("x-access-token")!),
    "x-customer-id": localStorage.getItem("x-customer-id")!,
  };
  return doGetExternalAppRequest(url, headers);
}

export function checkSmsPortability(sms: string): Promise<any> {
  const url = `/token/validate?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
    "x-customer-id": localStorage.getItem("x-customer-id")!,
    authorization: "Bearer ".concat(localStorage.getItem("x-access-token")!),
  };
  const payload = {
    token: sms,
    tokenOperation: "PORTABILITY_TOKEN",
  };
  return doPostExternalAppRequest(url, payload, headers);
}

export function requestPortability(productId: string): Promise<any> {
  const url = `/portability/request?productId=${productId}&gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
    "x-customer-id": localStorage.getItem("x-customer-id")!,
    "x-msisdn": `55${localStorage.getItem("msisdn")!}`,
    authorization: "Bearer ".concat(localStorage.getItem("x-access-token")!),
  };

  return doPutExternalAppRequest(url, {}, headers);
}

export function registerPortability(payload: any): Promise<any> {
  const url = `/portability/msisdn/info?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
    "x-customer-id": localStorage.getItem("x-customer-id")!,
    authorization: "Bearer ".concat(localStorage.getItem("x-access-token")!),
  };
  return doPostExternalAppRequest(url, payload, headers);
}
